import { createReducer } from '@reduxjs/toolkit'
import * as types from './types'

const initialState = {
  isFetching: false,
  isError: false,
  isSuccess: false,
  currentItem: {},
  items: [],
  pagination: {
    total: 1,
    page: 1,
    pageCount: 1
  },
  mediationRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  },
  groupRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  },
  privateRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  },
  archivedRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  }
}

const chatsReducer = createReducer(initialState, {
  [types.GET_CHATS]: (state, action) => {
    if (action?.payload?.archivedRooms) {
      return {
        ...state,
        archivedRooms: {
          ...state.archivedRooms,
          isFetching: true
        }
      }
    } else {
      if (action?.payload?.room_type === 1) {
        return {
          ...state,
          privateRooms: {
            ...state.privateRooms,
            isFetching: true
          }
        }
      } else if (action?.payload?.room_type === 0) {
        return {
          ...state,
          groupRooms: {
            ...state.groupRooms,
            isFetching: true
          }
        }
      } else if (action?.payload?.room_type === 2) {
        return {
          ...state,
          mediationRooms: {
            ...state.mediationRooms,
            isFetching: true
          }
        }
      } else {
        return {
          ...state,
          isFetching: true
        }
      }
    }
  },
  [types.GET_PRIVATE_ROOMS_SUCCESSFUL]: (state, action) => ({
    ...state,
    privateRooms: {
      ...state.privateRooms,
      items: [...state.privateRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  [types.SET_PRIVATE_ROOMS_ORDER]: (state, action) => ({
    ...state,
    privateRooms: {
      ...state.privateRooms,
      items: [...action.payload.data]
    }
  }),
  [types.GET_GROUP_ROOMS_SUCCESSFUL]: (state, action) => ({
    ...state,
    groupRooms: {
      ...state.groupRooms,
      items: [...state.groupRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  [types.GET_ARCHIVED_ROOMS_SUCCESSFUL]: (state, action) => ({
    ...state,
    archivedRooms: {
      ...state.archivedRooms,
      items: [...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  [types.SET_GROUP_ROOMS_ORDER]: (state, action) => ({
    ...state,
    groupRooms: {
      ...state.groupRooms,
      items: [...action.payload.data]
    }
  }),
  [types.GET_MEDIATION_ROOMS_SUCCESSFUL]: (state, action) => ({
    ...state,
    mediationRooms: {
      ...state.mediationRooms,
      items: [...state.mediationRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  [types.SET_MEDIATION_ROOMS_ORDER]: (state, action) => ({
    ...state,
    mediationRooms: {
      ...state.mediationRooms,
      items: [...action.payload.data]
    }
  }),
  [types.CLEAR_ARCHIVED_ROOMS]: (state, action) => ({
    ...state,
    archivedRooms: {
      ...initialState.archivedRooms
    }
  }),
  [types.CLEAR_MEDIATION_ROOMS]: (state, action) => ({
    ...state,
    mediationRooms: {
      ...initialState.mediationRooms
    }
  }),
  [types.CLEAR_PRIVATE_ROOMS]: (state, action) => ({
    ...state,
    privateRooms: {
      ...initialState.privateRooms
    }
  }),
  [types.CLEAR_GROUP_ROOMS]: (state, action) => ({
    ...state,
    groupRooms: {
      ...initialState.groupRooms
    }
  }),
  [types.GET_CHATS_SUCCESSFUL]: (state, action) => ({
    ...state,
    items: action.payload.data,
    isSuccess: true,
    pagination: {
      total: action.payload.meta.total_count,
      pageCount: action.payload.meta.page_count
    },
    isFetching: false
  }),
  [types.GET_CHATS_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    items: [],
    isError: true,
    errorMessage: action.payload
  }),
  [types.GET_CHAT_BY_ID]: (state, action) => ({
    ...state,
    currentItem: {},
    isFetching: true,
    isSuccess: false
  }),
  [types.GET_CHAT_BY_ID_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isSuccess: true,
    currentItem: action.payload.data
  }),
  [types.GET_CHAT_BY_ID_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    currentItem: {},
    isError: true,
    errorMessage: action.payload
  }),
  [types.UPDATE_GROUP_ROOM_REDUCER]: (state, action) => {
    return {
      ...state,
      currentItem:
        +state?.currentItem?.id === +action.payload.id
          ? { ...state.currentItem, name: action.payload.name }
          : state.currentItem,
      groupRooms: {
        ...state.groupRooms,
        items: state.groupRooms?.items.map(item => {
          if (+item.id === +action.payload.id) {
            return { ...item, name: action.payload.name }
          }
          return { ...item }
        })
      },
      mediationRooms: {
        ...state.mediationRooms,
        items: state.mediationRooms?.items.map(item => {
          if (+item.id === +action.payload.id) {
            return { ...item, name: action.payload.name }
          }
          return { ...item }
        })
      }
    }
  },
  [types.UPDATE_ROOM_UNREAD_COUNT]: (state, action) => {
    const { room_id, room_unread_count } = action.payload
    const updatePendingCount = item =>
      +item.id === +room_id
        ? { ...item, pending_messages_count: room_unread_count }
        : item
    const moveToTop = items => {
      const updatedItems = items.map(updatePendingCount)
      const roomIndex = updatedItems.findIndex(item => +item.id === +room_id)
      if (roomIndex === -1) return items
      const [room] = updatedItems.splice(roomIndex, 1)
      return [room, ...updatedItems]
    }
    return {
      ...state,
      privateRooms: {
        ...state.privateRooms,
        items: moveToTop(state.privateRooms?.items)
      },
      groupRooms: {
        ...state.groupRooms,
        items: moveToTop(state.groupRooms?.items)
      },
      mediationRooms: {
        ...state.mediationRooms,
        items: moveToTop(state.mediationRooms?.items)
      }
    }
  },
  [types.FILTER_ARCHIVED]: (state, action) => ({
    ...state,
    privateRooms: {
      ...state.privateRooms,
      items: state.privateRooms.items.filter(
        item => +item.id !== +action.payload
      )
    },
    groupRooms: {
      ...state.groupRooms,
      items: state.groupRooms.items.filter(item => +item.id !== +action.payload)
    },
    mediationRooms: {
      ...state.mediationRooms,
      items: state.mediationRooms.items.filter(
        item => +item.id !== +action.payload
      )
    }
  })
})

export default chatsReducer
